import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BlogDet = () => {
  const location = useLocation();
  const { blog } = location.state || {};  // Retrieve the blog data passed in navigation

  useEffect(()=>{
    window.scroll(0,0)
  },[])

  if (!blog) {
    return <p>No blog found.</p>;
  }
 

  return (
    <div className="container mx-auto p-4 max-w-3xl">
      <h1 className="text-3xl font-bold mb-4">{blog.title}</h1>
      <img src={blog.image} alt={blog.title} className="w-full h-auto mb-4 rounded-lg" />
      <div className="text-gray-700" dangerouslySetInnerHTML={{ __html: blog.content }}></div>
    </div>
  );
};

export default BlogDet;
